import { render } from "./TestResultStudent.vue?vue&type=template&id=12fc36d9&scoped=true"
import script from "./TestResultStudent.vue?vue&type=script&lang=js"
export * from "./TestResultStudent.vue?vue&type=script&lang=js"

import "./TestResultStudent.vue?vue&type=style&index=0&id=12fc36d9&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\Edu Katta\\Private\\Edukatta_Private_Managment_UI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12fc36d9"]])

export default __exports__